import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cilAccountLogout,

} from "@coreui/icons";
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl, cifIr } from "@coreui/icons";
import {
  cilArrowRight,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cilPlus,
  cilX,
  cilHome,
  cilCarAlt,
  cilMobile,
  cilLoopCircular,
  cilBalanceScale,
  cilGroup,
  cilTruck,
  cilBuilding,
  cilBriefcase,
  cilDevices,
  cilGauge,
  cilFilter,
  cilFactory,
  cilHamburgerMenu,
  cilDiamond,
  cilClock,
  cilSpreadsheet,
  cilPaperPlane,
  cilTrash,
  cilChartLine,
  cilSearch,
  cilCamera,
  cilSignalCellular3,
  cilMoney,
  cilInputPower,
  cilBattery3,
  cilSim,
  cilLan,
  cilPrint,
  cilContact,
  cilRouter,
  cilMemory,
  cilTouchApp,
  cilChart,
  cilLoop,
  cilMediaStepForward,
  cilBarChart,
  cilObjectGroup,
  cilCommand,
  cilDoor,
  cilSnowflake,
  cilChevronDoubleDown,
  cilChevronDoubleUp,
  cilAperture,
  cilCog,
  cilCash,
  cilBank,
  cilLibraryBuilding,
  cilPhone,
  cilHandPointUp

} from "@coreui/icons";
import { logo } from "./logo";

export const iconsSet = Object.assign(
  {},
  { logo },
  {
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilPlus,
    cilX,
    cilHome,
    cilCarAlt,
    cilMobile,
    cilLoopCircular,
    cilBalanceScale,
    cilGroup,
    cilTruck,
    cilBuilding,
    cilBriefcase,
    cilDevices,
    cilGauge,
    cilFilter,
    cilFactory,
    cilHamburgerMenu,
    cilDiamond,
    cilClock,
    cilSpreadsheet,
    cilPaperPlane,
    cilTrash,
    cilChartLine,
    cilSearch,
    cilCamera,
    cilSignalCellular3,
    cilMoney,
    cilInputPower,
    cilBattery3,
    cilSim,
    cilLan,
    cilPrint,
    cilContact,
    cilRouter,
    cilMemory,
    cilTouchApp,
    cilChart,
    cilLoop,
    cilMediaStepForward,
    cilBarChart,
    cilObjectGroup,
    cilCommand,
    cilDoor,
    cilSnowflake,
    cilChevronDoubleDown,
    cilChevronDoubleUp,
    cilAperture,
    cilCog,
    cilCash,
    cilAccountLogout,
    cilBank,
    cilLibraryBuilding,
    cilPhone,
    cilHandPointUp



  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
    cifIr
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex,

  }
);
